import React from "react";
import Image from "next/image";
import { ChakraBox } from "ui/chakra-framer";

type HeadingIconProps = {
  src: string;
  alt: string;
  priority?: boolean; // eslint-disable-line react/boolean-prop-naming
  isFirstLoop?: boolean;
};

export function HeadingIcon({ src, alt, priority = false, isFirstLoop = false }: HeadingIconProps) {
  return (
    <ChakraBox
      position="absolute"
      inset={0}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.35, delay: isFirstLoop ? 0.8 : 0.5 } }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.35,
        },
      }}
    >
      <Image
        fill
        sizes="100%"
        src={src + "?w=72"}
        alt={`${alt}.`}
        priority={priority}
        style={{
          objectFit: "contain",
        }}
      />
    </ChakraBox>
  );
}
